module.exports = __webpack_public_path__ + "img/GI.c0e73633.svg";